import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useMemo, useEffect, useState, Fragment } from 'react';
import List from '@mui/material/List';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useTheme } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import useWidgetStore from '../../store/useWidgetStore';
import useDataStore from '../../store/useDataStore';
import ObjectListPicker from './ObjectListPicker';
import { useI18N } from '../../context/I18NContext';
import { useSettings } from '../../context/SettingsContext';
import { CustomTextFieldElement } from '../../layouts/Theme';
import { useFormContext } from 'react-hook-form';
export default function ObjectGroupedListPicker(props) {
    const theme = useTheme();
    const { t } = useI18N();
    const { enabled, setEnabled } = useWidgetStore();
    const { widgetMode } = useSettings();
    const { setValue } = useFormContext();
    const isDesktop = window.screen.width > 500;
    const [selected, setSelected] = useState(0);
    const [total, setTotal] = useState(0);
    const [follow, setFollow] = useState(false);
    const [search, setSearch] = useState('');
    // for tabs
    const handleChange = (event, groupId) => {
        setFollow(false);
        setSelected(groupId);
        const element = document.getElementById(`group_${groupId}`);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                // @ts-ignore
                container: 'nearest'
            });
            var observer = new IntersectionObserver(function (entries) {
                window.scrollTo({ top: 0 });
            }, { threshold: [0] });
            observer.observe(element);
        }
    };
    const { apptypes, products, resources } = useDataStore();
    useEffect(() => {
        switch (props.source) {
            case "group":
                if (!enabled.apptype) {
                    setEnabled(Object.assign(Object.assign({}, enabled), { apptype: true }));
                }
                ;
                break;
            case "category":
                if (!enabled.product) {
                    setEnabled(Object.assign(Object.assign({}, enabled), { product: true }));
                }
                ;
                break;
        }
    }, [props.source]);
    let previousY = [];
    let previousRatio = [];
    useEffect(() => {
        let sections = document.querySelectorAll(".category-section");
        setTotal(sections.length);
        const observers = [];
        if (sections) {
            sections.forEach((section) => {
                var observer = new IntersectionObserver(function (entries) {
                    let sectionId = parseInt(entries[0].target.id.substring(6)), entry = entries[0];
                    const currentY = entry.boundingClientRect.y;
                    const currentRatio = entry.intersectionRatio;
                    const isIntersecting = entry.isIntersecting;
                    if (currentY < previousY[sectionId]) {
                        if (currentRatio > previousRatio[sectionId] && isIntersecting) {
                            //console.log(`Scrolling down enter ${sectionId} ${selected}`)
                            // setSelected(sectionId)
                        }
                        else {
                            // console.log(`Scrolling down exit ${sectionId} ${selected}`)
                            if (sectionId < sections.length - 1) {
                                if (follow) {
                                    setSelected(sectionId + 1);
                                }
                                else if (sectionId === selected - 1) {
                                    // console.log('reached target, enable follow again')
                                    setFollow(true);
                                    setSelected(sectionId + 1);
                                }
                            }
                        }
                    }
                    else if (currentY > previousY[sectionId] && isIntersecting) {
                        if (currentRatio >= previousRatio[sectionId]) {
                            // console.log(`Scrolling up enter ${sectionId} ${selected}`)
                            if (follow) {
                                setSelected(sectionId);
                            }
                            else if (sectionId === selected) {
                                // console.log('reached target, enable follow again')
                                setFollow(true);
                                setSelected(sectionId);
                            }
                        }
                        else {
                            // console.log(`Scrolling up leave ${sectionId} ${selected}`)
                        }
                    }
                    previousY[sectionId] = currentY;
                    previousRatio[sectionId] = currentRatio;
                }, { threshold: [0] });
                observer.observe(section);
                observers.push(observer);
            });
        }
        return () => {
            observers.forEach((observer) => {
                observer.disconnect();
            });
        };
    }, [apptypes, products, follow]);
    const renderComponents = useMemo(() => {
        var _a;
        let hasGlobalAny = false;
        const categories = (_jsx(_Fragment, { children: props.data && props.data.map && props.data.map((row, i) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
                let _apptypes = apptypes.filter((apptype) => {
                    // check if this apptype is part of this group
                    return apptype.parentId === row.id;
                });
                if (_apptypes.length === 0) {
                    return (_jsx(Fragment, {}, i));
                }
                let hasAny = false;
                if (search !== '') {
                    _apptypes.map((row, i) => {
                        if (row.name.toUpperCase().includes(search.toUpperCase())) {
                            hasAny = true;
                            hasGlobalAny = true;
                        }
                    });
                }
                return (_jsx(Fragment, { children: (search === '' || hasAny) && (_jsxs(Box, { sx: {
                            marginTop: 3,
                            paddingBottom: 3
                        }, children: [_jsx(Typography, { className: "category-section", sx: {
                                    marginLeft: 2,
                                    fontWeight: 500,
                                    textTransform: 'uppercase',
                                    // fontSize: '1.25rem',
                                    fontFamily: "DM Sans",
                                    color: theme.palette.text.primary,
                                    scrollMarginTop: '100px'
                                }, id: `group_${i}`, children: row.name }), _jsx(ObjectListPicker, { source: "apptype", data: _apptypes, config: {
                                    showDescription: (_b = (_a = props === null || props === void 0 ? void 0 : props.config) === null || _a === void 0 ? void 0 : _a.showDescription) !== null && _b !== void 0 ? _b : true,
                                    showImage: (_d = (_c = props === null || props === void 0 ? void 0 : props.config) === null || _c === void 0 ? void 0 : _c.showImage) !== null && _d !== void 0 ? _d : false,
                                    imageVariant: (_f = (_e = props === null || props === void 0 ? void 0 : props.config) === null || _e === void 0 ? void 0 : _e.imageVariant) !== null && _f !== void 0 ? _f : 'circular',
                                    showDuration: (_h = (_g = props === null || props === void 0 ? void 0 : props.config) === null || _g === void 0 ? void 0 : _g.showDuration) !== null && _h !== void 0 ? _h : false,
                                    showPrice: (_k = (_j = props === null || props === void 0 ? void 0 : props.config) === null || _j === void 0 ? void 0 : _j.showPrice) !== null && _k !== void 0 ? _k : false,
                                    showAnyOption: (_m = (_l = props === null || props === void 0 ? void 0 : props.config) === null || _l === void 0 ? void 0 : _l.showAnyOption) !== null && _m !== void 0 ? _m : false,
                                    multiSelect: (_p = (_o = props === null || props === void 0 ? void 0 : props.config) === null || _o === void 0 ? void 0 : _o.multiSelect) !== null && _p !== void 0 ? _p : false,
                                    defaultValue: (_r = (_q = props === null || props === void 0 ? void 0 : props.config) === null || _q === void 0 ? void 0 : _q.defaultValue) !== null && _r !== void 0 ? _r : false,
                                    maxSelect: (_t = (_s = props === null || props === void 0 ? void 0 : props.config) === null || _s === void 0 ? void 0 : _s.maxSelect) !== null && _t !== void 0 ? _t : undefined,
                                    resetSelection: (_v = (_u = props === null || props === void 0 ? void 0 : props.config) === null || _u === void 0 ? void 0 : _u.resetSelection) !== null && _v !== void 0 ? _v : undefined,
                                    search: search,
                                    isGrouped: true
                                } })] })) }, i));
            }) }));
        return (_jsxs(Box, { sx: {
                minWidth: 120,
                maxWidth: '100%',
                height: widgetMode === "standalone"
                    ? (isDesktop
                        // 201px from BasicNav, + 56px for tabs
                        ? 'calc(100dvh - 257px)'
                        // 98px from BasicNav, + 40px for tabs
                        : 'calc(100dvh - 138px)')
                    : 'calc(100dvh - 96px)',
                overflowY: 'scroll',
                "&::-webkit-scrollbar": {
                    width: '4px',
                    height: '10px'
                },
                "&::-webkit-scrollbar-thumb": {
                    background: theme.palette.primary.main,
                    borderRadius: '1px'
                },
                "&::-webkit-scrollbar-track": {
                    background: 'transparent'
                },
                "&::-webkit-scrollbar-corner": {
                    background: 'transparent'
                },
            }, children: [((_a = props === null || props === void 0 ? void 0 : props.config) === null || _a === void 0 ? void 0 : _a.hasSearch) && (_jsx(Box, { sx: {
                        backgroundColor: 'rgba(0,0,0,0.1)', //theme.palette.background.paper,
                        zIndex: 1000,
                        position: 'sticky',
                        top: 0,
                        boxShadow: '0 16px 16px 0 rgba(0,0,0,0.1)',
                    }, children: _jsx(CustomTextFieldElement
                    // label={t('Zoeken')}
                    , { 
                        // label={t('Zoeken')}
                        name: 'search', type: 'input', onKeyUp: handleSearch, 
                        // fullWidth
                        sx: {
                            marginLeft: 1,
                            marginBottom: 0,
                            width: 'calc(100% - 16px)',
                            fontSize: '0.75rem',
                            color: theme.palette.text.primary,
                            backgroundColor: theme.palette.background.default
                        }, InputProps: {
                            startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(SearchIcon, { sx: { color: theme.palette.text.secondary } }) })),
                            endAdornment: (_jsx(InputAdornment, { position: "end", children: search !== '' && (_jsx(Button, { onClick: clearSearch, children: _jsx(CloseIcon, {}) })) })),
                            sx: {
                                fontSize: '0.75rem',
                                backgroundColor: theme.palette.background.paper
                            }
                        } }) })), (search === '' || hasGlobalAny) && (_jsx(List, { sx: {
                        width: '100%',
                        marginTop: '32px',
                        marginBottom: '64px',
                        paddingBottom: '64px'
                    }, children: categories })), (search !== '' && !hasGlobalAny) && (_jsx(Typography, { variant: 'h6', sx: {
                        marginX: 2,
                        marginY: 4,
                        textAlign: 'center',
                        fontSize: '1rem',
                        fontWeight: 500,
                        fontStyle: 'italic'
                    }, children: t('Er zijn geen afspraaktypen gevonden', 'select') }))] }));
    }, [apptypes, products, search]);
    const handleSearch = (event) => {
        setSearch(event.target.value);
        // todo, scroll to the first category in view
        // todo, notify when no search results
    };
    const clearSearch = (event) => {
        setSearch('');
        setValue('search', '');
    };
    return (_jsxs(_Fragment, { children: [_jsx(Box, { sx: Object.assign({ position: 'sticky', top: 0, marginLeft: 0, background: theme.palette.background.paper, zIndex: 1000, paddingTop: '8px', width: '100%', boxShadow: '0 16px 16px 0 rgba(0,0,0,0.1)' }, (isDesktop && {
                    width: '500px'
                })), children: _jsx(Tabs, { value: selected, onChange: handleChange, role: "navigation", variant: "scrollable", scrollButtons: true, allowScrollButtonsMobile: true, sx: Object.assign(Object.assign(Object.assign(Object.assign({ mx: 1, width: 'calc(100% - 16px)', '& .MuiTabs-flexContainer': {
                            width: 'calc(100% + 16px)'
                        }, '& .MuiTabs-indicator': {
                            display: 'none'
                        }, "& .MuiTabs-scrollButtons": {
                            width: '20px', // default 40
                            height: '36px',
                        } }, (selected > 0 && {
                        "& > div:nth-of-type(1)": {
                            borderRight: theme.palette.mode === "dark" ? '#333 1px solid' : '#f0f0f0 1px solid'
                        }
                    })), (selected < total && {
                        "& > div:nth-of-type(4)": {
                            borderLeft: theme.palette.mode === "dark" ? '#333 1px solid' : '#f0f0f0 1px solid'
                        }
                    })), (theme.palette.mode === "dark" && {
                        "& .MuiTabs-scrollButtons": {
                            color: '#fff'
                        }
                    })), { "& .MuiTabs-scrollButtons.Mui-disabled": {
                            opacity: 0.3
                        } }), children: props.data && props.data.map && props.data.map((row, i) => {
                        let _apptypes = apptypes.filter((apptype) => {
                            return apptype.parentId === row.id;
                        });
                        if (_apptypes.length === 0) {
                            return (_jsx(Fragment, {}, i));
                        }
                        return (_jsx(Tab, { label: row.name, sx: {
                                textTransform: 'none',
                                backgroundColor: theme.palette.background.default,
                                color: theme.palette.text.primary,
                                border: theme.palette.mode === 'dark' ? '#333 1px solid' : '#ccc 1px solid',
                                borderRadius: '16px',
                                fontWeight: 700,
                                fontSize: '1rem',
                                minHeight: 0,
                                paddingY: 1,
                                paddingX: 2,
                                marginLeft: 0,
                                marginRight: 2,
                                "&.Mui-selected": {
                                    backgroundColor: theme.palette.mode === 'dark' ? '#333' : theme.palette.primary.main,
                                    borderColor: theme.palette.mode === 'dark' ? '#333' : theme.palette.primary.main,
                                    color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText
                                }
                            } }, i));
                    }) }) }), renderComponents] }));
}
